<template>
    <form method="post" @submit.prevent="onSubmit">
        <div class="form-block--secondary">
            <div class="form__row">
                <div class="form__item">
                    <phase-autocomplete :v="$v" ref="phase" @change="onChange" :as-select="true" name="form.phaseId"
                                        v-model="$v.form.phaseId.$model" length-type="w--xl"/>
                    <div class="z1">
                        <button type="button" @click="createPhase" iconic class="m--t-1"><span icon create></span>Založit
                            etapu
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="elementary-section__controls button-fix">
            <custom-button type="submit" small outline v-bind:class="{'no-updates': !formChanged}">Uložit
            </custom-button>
        </div>
    </form>
</template>

<script>
import PhaseAutocomplete from '@/components/Autocomplete/PhaseAutocomplete';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CreatePhaseDialog from '@/modules/ProjectModule/modules/OptionModule/components/Phase/CreatePhaseDialog';

export default {
    name:        'OtherForm',
    components:  {
        CustomButton,
        PhaseAutocomplete
    },
    data() {
        return {
            formChanged: false,
            form:        {
                phaseId: null,
            },
        }
    },
    validations: {
        form: {
            phaseId: {},
        },
    },
    computed:    {
        phaseId() {
            return this.$store.getters['projects/project/units/unit/phaseId'];
        }
    },
    mounted() {
        this.$refs.phase.setSelectedId(this.phaseId);
    },
    methods:     {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const {phaseId, floorPlanId} = this.form;
                this.$emit('o3-submit', {phaseId, floorPlanId});
            }
        },
        onChange() {
            this.formChanged = true;
        },
        createPhase() {
            this.$modal.show(CreatePhaseDialog, {}, defaultModalParameters());
        }
    }
}
</script>
